import { G2ComparisonType } from '../components/G2Comparison'
import { AlternativeType } from '../types'
import MergeLogo from './images/merge-logo.svg'
import MergeIcon from './images/merge-icon.svg'

export const linkToG2 = 'https://www.g2.com/compare/integration-app-vs-merge'

export const g2Comparison: G2ComparisonType = {
  name: 'Merge.dev',
  logo: MergeLogo.src,
  stars: 5,
  reviews: 220,
  markerSegment: (
    <>
      <b>Small-Business</b> (62.9% of reviews)
    </>
  ),
  entryLevelPricing: (
    <>
      <b>Free</b> 3 production-linked accounts per month
    </>
  ),
}

export const alternative: AlternativeType = {
  name: 'Merge.dev',
  logo: MergeLogo,
  icon: MergeIcon,
  comparison_table: {
    non_developer_support: 'Drag-and-drop workflow builder',
    developer_support: 'Limited to recipes, connections, and joins',
    on_premise_option: false,
    end_user_ui: 'Iframe, Workato-branded',
    connector_library: '~200',
    custom_connectors: 'Partially supported (OAuth, actions)',
  },
}
